import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex } from "@/eworkitComponents";

interface IOnboardingProfileTypeBoxProps {}

export const OnboardingProfilesHeader: FC<IOnboardingProfileTypeBoxProps> = () => {
  const { t } = useTranslation("session");
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Flex
      grow={1}
      direction={isSmallScreen ? "column" : "row"}
      innerMargin="md"
      border={[false, false, true, false]}
      padding={["sm", false]}>
      <Flex width={4} padding={isSmallScreen ? [false] : [false, false, false, "xl"]}>
        <Text color="grey1" size="md">
          {t("ONBOARDING.PROFILES_LIST.LIST.HEADERS.PROFILE_NAME")}
        </Text>
      </Flex>
      <Flex width={4}>
        <Text color="grey1" size="md">
          {t("ONBOARDING.PROFILES_LIST.LIST.HEADERS.CREATED_BY")}
        </Text>
      </Flex>
      <Flex width={2}>
        <Text color="grey1" size="md">
          {t("ONBOARDING.PROFILES_LIST.LIST.HEADERS.COMPANY")}
        </Text>
      </Flex>
      <Flex width={2}>
        <Text color="grey1" size="md">
          {t("ONBOARDING.PROFILES_LIST.LIST.HEADERS.PROFILE_TYPE")}
        </Text>
      </Flex>
    </Flex>
  );
};
